import { observer } from 'mobx-react-lite'
import React, { useEffect, useRef } from 'react'
import classNames from 'classnames'
import { IconButton, type ITabItem, type IType, Tabs, Type } from 'shared/ui'
import { RcsEmptyFallbackInboxAlert, RcsNotSupportedFilesAlert, SendFromRcs } from 'entities/Rcs/ui'
import { useCampaignMessageContext } from 'pages/campaigns/ui/CampaignMessage'
import { CampaignSMS } from 'pages/campaigns/ui/CampaignSMS'
import { CampaignRingless } from 'pages/campaigns/ui/CampaignRingless'
import { CampaignSendFrom } from 'pages/campaigns/ui/CampaignSendFrom'
import {
  type IMessageActionsProps,
  MessageActions,
} from 'pages/campaigns/ui/CampaignMessage/ui/MessageContent/MessageActions/MessageActions'
import { Title } from 'pages/campaigns/ui/CampaignMessage/ui/MessageContent/Title/Title'
import styles from './styles.module.scss'

export type IMessageContentProps = {
  index: number
} & IMessageActionsProps

export const MessageContent = observer(
  ({ index, ...messageActionsProps }: IMessageContentProps) => {
    const refContent = useRef<HTMLDivElement>(null)
    const {
      setStep,
      type,
      setType,
      campaignSMSStore,
      campaignRinglessStore,
      campaignSendFromStore,
      setCollapse,
      isCollapse,
      tabs,
      rcsInbox,
      campaignSMSStore: {
        messageFieldStore: { showRcsNotSupportedFilesAlert, setShowRcsNotSupportedFilesAlert },
      },
    } = useCampaignMessageContext()

    useEffect(() => {
      setStep(index + 1)
    }, [index])

    const handleSelectTab = (tab: ITabItem<IType>) => {
      setType(tab.key)
    }

    return (
      <div className={classNames(styles.wrap, { [styles.collapse]: isCollapse })}>
        <div className={styles.content} ref={refContent}>
          <div className={styles.header} onClick={() => setCollapse(false)}>
            <Title contentElement={refContent.current} />
            <div className={styles.right} onClick={(event) => event.stopPropagation()}>
              <Type type={type} />
              <MessageActions {...messageActionsProps} />
            </div>
          </div>
          {!isCollapse && (
            <>
              <Tabs
                variant={'simple'}
                tabs={tabs}
                activeTabKey={type}
                handleSelectTab={handleSelectTab}
              />
              {showRcsNotSupportedFilesAlert && type === 'rcs' && (
                <RcsNotSupportedFilesAlert
                  alertProps={{ marginTop: 8, marginBottom: 4 }}
                  onClose={() => setShowRcsNotSupportedFilesAlert(false)}
                />
              )}
              {(type === 'sms' || type === 'rcs') && <CampaignSMS store={campaignSMSStore} />}
              {type === 'ringless' && <CampaignRingless store={campaignRinglessStore} />}
              {type === 'rcs' && (
                <RcsEmptyFallbackInboxAlert alertProps={{ marginTop: 32, marginBottom: 16 }} />
              )}
              {showRcsNotSupportedFilesAlert && type === 'rcs' && (
                <RcsNotSupportedFilesAlert
                  alertProps={{ marginTop: 8, marginBottom: 4 }}
                  onClose={() => setShowRcsNotSupportedFilesAlert(false)}
                />
              )}
              <div className={styles.wrapSendFrom}>
                {(type === 'sms' || type === 'ringless') && (
                  <CampaignSendFrom store={campaignSendFromStore} />
                )}
                {type === 'rcs' && rcsInbox && <SendFromRcs inbox={rcsInbox} />}
              </div>
            </>
          )}
        </div>
        {!isCollapse && (
          <IconButton
            ariaLabel={'collaapse'}
            icon={'chevronUp'}
            variant={'icon'}
            color={'tertiary'}
            fullWidth
            onClick={() => setCollapse(true)}
          />
        )}
      </div>
    )
  }
)
